<!-- CARD -->
<div class="card m-auto" style="max-width: 450px">
  <div class="card-body">
    <div class="w-100 m-auto pt-3" style="max-width: 250px">
      <app-rag-logo></app-rag-logo>
    </div>
    <!-- title -->
    <h4 class="text-center my-4">{{ this.roomName }}</h4>
    <div class="w-50 m-auto"></div>
    <div
      *ngIf="infoText"
      class="alert alert-info text-center"
      [innerHtml]="bbparse(infoText)"
    ></div>
    <div
      *ngIf="warnText"
      class="alert alert-warning text-center"
      [innerHtml]="bbparse(warnText)"
    ></div>
    <div
      *ngIf="dangerText"
      class="alert alert-danger text-center"
      [innerHtml]="bbparse(dangerText)"
    ></div>
    <ng-content></ng-content>
  </div>
</div>
